import useOnClickOutside from '@/core/hooks/useOnClickOutside/useOnClickOutside';

export default useOnClickOutside;
